<template>
  <div class="warp">
    <!-- 头部 -->
    <div class="warpTop">
      <div class="warpTopsCent">
        <img class="warpTopsCentL" :src="video.surfacePlot" />

        <div class="warpTopsCentR">
          <div class="title dis_flex">
            <div class="courType">录播</div>
            {{ video.courseName }}
          </div>
          <div class="detail-ter m-t-20 flex-c">
            <div class="ter-list">
              <div class="terbox" @click="goNext(`/faculty/teacherDetail?id=${video.teacherId}`)">
                <el-image class="ter-img" :src="video ? video.teacherPortrait : ''" fit="cover" />
              </div>
              <span class="ter">讲师：{{ video ? video.teacherName : "" }}</span>
            </div>
          </div>
          <div v-if="!priceShow" class="vip_box">
            <div class="content_box">
              <div class="vip_title m_r_2">课程服务</div>
              <div class="vip_content">随堂讲义/随堂资料/随堂测试</div>
            </div>
            <div class="content_box">
              <div class="vip_title em">课时</div>
              <div class="vip_content">{{ video.ksTime }}课时</div>
            </div>
          </div>

          <div v-if="priceShow">
            <div v-if="university != 1" class="picr">
              <div>价格</div>
              <div class="spanb">
                ￥{{ video.currentPrice ? video.currentPrice : 0 }}
              </div>
            </div>

            <div v-if="university != 1" class="btn">
              <div v-if="!IsPurchase" class="keep-learn keep-check" @click="yuyue(1)">
                立即购买
              </div>
              <div v-else class="keep-learn" @click="yuyue(2)">已购买</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="box-content">
        <!-- 选项栏 -->
        <div class="warpnav">
          <div class="warpnavs">
            <div class="warpnavsCons" :class="navIndex == 1 ? 'on' : ''" @click="navs(1)">
              <span>课程详情</span>
              <div v-if="navIndex == 1" />
            </div>

            <div class="warpnavsCons" :class="navIndex == 2 ? 'on' : ''" @click="navs(2)">
              <span>课程列表</span>
              <div v-if="navIndex == 2" />
            </div>
            <div v-if="dataShow" class="warpnavsCons" :class="navIndex == 3 ? 'on' : ''" @click="navs(3)">
              <span>课程资料</span>
              <div v-if="navIndex == 3" />
            </div>
            <div v-if="mkdataShow" class="warpnavsCons" :class="navIndex == 4 ? 'on' : ''" @click="navs(4)">
              <span>课程测试</span>
              <div v-if="navIndex == 4" />
            </div>
            <div class="warpnavsCons" :class="navIndex == 5 ? 'on' : ''" @click="navs(5)">
              <span>课程评价</span>
              <div v-if="navIndex == 5" />
            </div>
            <div class="warpnavsCons" :class="navIndex == 10 ? 'on' : ''" @click="navs(10)">
              <span>主讲老师</span>
              <div v-if="navIndex == 10" />
            </div>
          </div>
        </div>
        <!-- 课程详情内容 -->
        <div v-if="navIndex == 1" class="warpCon">
          <div class="apple">
            <div class="appleLeft">
              <div class="appleLefts" v-html="ImgSizeLimit(video.summarizeContent)" />
            </div>
          </div>
        </div>
        <!-- 录播章节 -->
        <div v-if="navIndex == 2" class="warpCon">
          <video-chater :IsPurchase="IsPurchase" :id="id" :list="video.videoList" />
        </div>
        <!-- 课程资料 -->
        <div v-if="navIndex == 3" class="warpCon">
          <course-data :IsPurchase="IsPurchase" v-if="navIndex == 3" :id="video.belongCourseTitle" />
        </div>
        <!-- 课程模考 -->
        <div v-if="navIndex == 4" class="warpCon">
          <course-task :IsPurchase="IsPurchase" v-if="navIndex == 4" :id="video.belongCourseTitle" />
        </div>
        <!-- 课程评价 -->
        <div v-if="navIndex == 5" class="warpCon">
          <score-evaluation :IsPurchase="IsPurchase" v-if="navIndex == 5" :type="2" :type-id="id" :type-nmae="video.title"
            :course-data="video" />
        </div>
        <div v-if="navIndex == 10" class="warpCon warpCons">
          <classTeacher :id="id" />
        </div>
      </div>
      <you-love :id="id" class="youlove" :ifteacher="true" :type="3" />
    </div>

    <div v-if="isFreeze == 1" class="mask_layer">课程已冻结，请联系老师</div>
  </div>
</template>
<script>
import Vue from "vue";
import VideoChater from '@/components/Know/videoChater.vue'

import { getToken } from "@/api/cookies";
import { getDomain } from "@/api/cookies";
import classTeacher from "@/components/Know/classCom/classTeacherSingle.vue";

import YouLove from "@/components/Know/youLove.vue";
import CourseData from "@/components/Know/course/courseDataeight.vue";
import courseTask from "@/components/Know/course/courseTaskeight.vue";
import scoreEvaluation from "@/components/Know/course/scoreEvaluation.vue";
import { HomeClient } from "@/api/home";
const homeClient = new HomeClient();

export default {
  components: {
    VideoChater,
    YouLove,
    CourseData,
    courseTask,
    scoreEvaluation,
    classTeacher,
  },

  data() {
    return {
      video: {},
      navIndex: 2,
      yuyues: 2,
      IsPurchase: false, // 章节列表
      id: null,
      classId: null,
      productLine: null,
      cardCode: null,
      classProductLine: 0,
      isFreeze: null, // 是否冻结 0 否 1 是
      mkdataShow: true,
      dataShow: true,
      pkid: "",
      priceShow: true,
      domainInfo: {},
      university: "",
    };
  },
  created() {
    this.domainInfo = getDomain();

    this.id = this.$route.query.id;
    this.checkIsBuyByCommodityId();
    this.queryCourseJxyDetails();
  },
  methods: {
      checkIsBuyByCommodityId(){
      homeClient.checkIsBuyByCommodityId({
        videoCourseId: this.id,
      }).then((res) => {
        if (res.code == 0) {
          this.IsPurchase = res.data
        }
      })

    },
    async getContactPcPageList() {
      const params = new URLSearchParams({
        kcId: this.video.belongCourseTitle,
        oneLabelId: 2,
      });
      const res = await homeClient.getContactPcPageList(params);
      if (res.code == 0) {
        if (res.data.length > 0) {
          this.mkdataShow = true;
        }
      }
    },
    async getDocsPcPageList() {
      const params = new URLSearchParams({
        kcId: this.video.belongCourseTitle,
        oneLabelId: 2,
      });
      const res = await homeClient.getDocsPcPageList(params);
      if (res.code == 0) {
        if (res.data.length > 0) {
          this.dataShow = true;
        }
      }
    },
    queryCourseJxyDetails() {
      homeClient
        .queryCourseJxyDetails({
          courseId: this.id,
        })
        .then((res) => {
          if (res.code == 0) {
            this.video = res.data;
            this.getDocsPcPageList();
            this.getContactPcPageList();
          }
        });
    },

    // 预约按钮
    yuyue(index) {
      this.yuyues = index;
      if (index == 1) {
        const token = getToken();
        if (token) {
          let arr = [];
          let obj = {
            commodityTypeCode: this.video.courseType,
            commodityId: this.video.courseId,
            discount: 0,
          };
          arr.push(obj);
          console.log(arr, 'arr');
          homeClient
            .addPayOrders(arr, undefined)
            .then((res) => {
              if (res.code == 0) {
                this.$router.push(`/orders/${res.data.orderNum}`)
              } else {
                this.$message.error(res.msg)
              }
            })

        } else {
          Vue.prototype.goLoginView(true);
        }
      }
    },

    // 标签页切换
    navs(val) {
      this.navIndex = val;
    },
  },
};
</script>
<style lang="less" scoped>
.warp {
  width: 100%;
  height: 100%;
  margin-bottom: 60px;
  overflow: hidden;

  // 头部
  .warpTop {
    width: 100%;
    background: #ffffff;
    padding: 40px calc(50% - 610px);

    .warpTopsCent {
      width: 1220px;
      height: 225px;
      display: flex;
      justify-content: flex-start;
      align-items: center;

      // 左侧视频
      .warpTopsCentL {
        width: 338px;
        height: 225px;
        border-radius: 8px 8px 8px 8px;
        opacity: 1;
        margin-right: 28px;
        flex-shrink: 0;
      }

      // 右侧详情
      .warpTopsCentR {
        width: 100%;
        height: 100%;
        position: relative;

        // 标题
        .title {
          font-size: 24px;
          font-family: Microsoft YaHei-Regular;
          font-weight: 400;
          color: #333333;
          line-height: 24px;

          .courType {
            height: 24px;
            background: #ffffff;
            border-radius: 4px 4px 4px 4px;
            opacity: 1;
            border: 1px solid #ff7b1c;
            font-size: 14px;
            font-family: Microsoft YaHei-Regular;
            font-weight: 400;
            color: #ff7b1c;
            line-height: 22px;
            padding: 0px 11px;
            margin-right: 8px;
            flex-shrink: 0;
          }
        }

        .vip_box {
          margin-top: 24px;

          .content_box {
            display: flex;
            margin-bottom: 24px;

            .vip_title {
              // margin-right: 16px;
              flex-shrink: 0;
              flex-grow: 0;
              color: #666666;
              font-size: 14px;
            }

            .vip_content {
              color: #333333;
              font-size: 14px;
            }

            .m_r_2 {
              margin-right: 2em;
            }

            .em {
              letter-spacing: 2em;
            }
          }
        }

        // 价格
        .picr {
          width: 360px;
          height: 54px;
          line-height: 54px;
          background: #f5f7f9;
          border-radius: 4px 4px 4px 4px;
          opacity: 1;
          display: flex;
          align-items: center;
          padding: 0px 20px;
          font-size: 16px;
          font-family: Microsoft YaHei-Regular;
          font-weight: 400;
          color: #999999;
          line-height: 16px;
          margin-top: 20px;

          .spanb {
            font-size: 24px;
            color: #ff5e51;
            margin: 0px 8px;
          }
        }

        // 报名资讯按钮
        .btn {
          width: auto;
          height: 46px;
          margin-top: 30px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          position: absolute;
          bottom: 0px;

          // 立即报名
          .keep-learn {
            height: 40px;
            padding: 0px 28px;
            line-height: 38px;
            font-size: 16px;
          }
        }
      }
    }
  }

  // 选项栏
  .warpnav {
    width: 100%;
    margin: 0px auto;
    height: 66px;
    background: #ffffff;
    border-bottom: 1px solid #dddddd;
    padding: 0px 32px;
    line-height: 66px;

    // 缩宽
    .warpnavs {
      height: 100%;
      margin: auto;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      // 知识套餐概述
      /*  .warpnavsCons {
        width: auto;
        height: auto;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #666666;
      } */
      // 竖线

      // 转换内容 选中
      .on {
        height: 100%;

        span {
          font-weight: bold !important;
          color: #333333;
        }

        div {
          width: 30px;
          height: 3px;
          background: linear-gradient(90deg, #ff4027 0%, #ff5400 100%);
          margin-left: calc(50% - 15px);
          margin-top: -3px;
        }
      }

      // 转换内容 未选中
      .warpnavsCons {
        height: 100%;
        margin-right: 60px;

        span {
          font-size: 16px;
          font-family: Microsoft YaHei-Regular;
          font-weight: 400;
          color: #666666;
          cursor: pointer;
        }
      }
    }
  }

  // 直播课内容
  .warpCon {
    width: 100%;
    margin: 0px auto;
    background: #fff;

    // 缩宽
    .apple {
      width: 1200px;
      height: 100%;
      /* margin: 30px auto; */
      display: flex;
      justify-content: space-between;
      align-items: flex-start;

      .appleLeft {
        width: 750px;
        height: auto;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        background: #ffffff;
        display: flex;
        justify-content: center;
        align-items: flex-start;

        .appleLefts/deep/img {
          width: 700px;
          height: auto;
          margin-top: 25px;
        }
      }

      .appleRight {
        width: 430px;
        height: 1292px;
        background: #ffffff;

        .appleRightTop {
          width: auto;
          height: 20px;
          margin: 16px 22px;
          border-left: 6px solid #3855f9;
          padding: 0px 12px;
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #7e7e7e;
        }

        img {
          width: 376px;
          height: 209px;
          margin-top: 25px;
          margin-left: 27px;
          background: rgba(0, 0, 0, 0);
        }
      }
    }
  }
}

.content {
  display: flex;
  width: 1220px;
  margin: 20px calc(50% - 610px);

  .box-content {
    width: 880px;
    margin-right: 20px;
  }

  .youlove {
    width: 320px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    flex-shrink: 0px;
  }
}

.el-popover {
  overflow: hidden;
  padding: 0px;
}

.mask_layer {
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  z-index: 999999;
  position: fixed;
  background-color: #000000;
  opacity: 0.6;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.terbox {
  cursor: pointer;
}
</style>
